import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { Constants } from 'src/app/shared/constants';

@Component({
    selector: 'app-password-expiry-dialog',
    templateUrl: './password-expiry-dialog.component.html',
    styleUrls: ['./password-expiry-dialog.component.scss'],
    standalone: false
})
export class PasswordExpiryDialogComponent implements OnInit {

 dialogClosedFlag = false;
 passwordExpirydate: string;
 router: Router;
 dialogFlag: string;
 route: ActivatedRoute;
 portalName = '';

 constructor(public dialogRef: MatDialogRef<PasswordExpiryDialogComponent>,
             private localstorage: LocalStorageService , @Inject(MAT_DIALOG_DATA) public data: { expiryDate: string }) { }

 ngOnInit() {
   this.dialogFlag = JSON.stringify(this.dialogClosedFlag);
   this.passwordExpirydate = this.data.expiryDate;
   this.portalName = Constants.PORTAL_NAME;
   this.localstorage.setItem(Constants.DIALOG_FLAG, this.dialogFlag);
 }

 CloseDialog() {
   const self = this;
   this.localstorage.setItem(Constants.DIALOG_FLAG, 'true');
   self.dialogRef.close(false);
 }

 gochangepasswordComponent() {
   const self = this;
   this.localstorage.setItem(Constants.DIALOG_FLAG, 'true');
   self.dialogRef.close(false);
 }

}



